<template>
  <template v-if="stateReady">
    <input-with-label
      label="Gabarito"
      :required="required"
      v-slot="l"
      :id="stateId + '_gabarito'"
      :hasValue="!!gabaritoInterno?.idOrgao"
    >
      <Dropdown
        v-model="gabaritoInterno"
        :options="gabaritosDisponiveisInternal"
        optionLabel="nome"
        :placeholder="'&nbsp;'"
        :showClear="true"
        :id="l.id"
        :required="l.required"
        :disabled="!!readOnly"
        v-focus="focus"
        :filter="true"
        filterPlaceholder="Nome do Gabarito"
      />
    </input-with-label>
  </template>
</template>

<script lang="ts">
import {
  defineComponent,
  toRefs,
  reactive,
  PropType,
  onMounted,
  watch,
  computed
} from "vue";
import {
  useGabaritoService,
  GabaritoPayload
} from "../../../modules/business/licenca/gabaritoBusiness";

//TODO KAIO TROCAR OS ENTITYSELECTORS PARA USAR V-MODEL
interface GabaritoSelectorState {
  stateReady: boolean;
  gabaritoInterno?: GabaritoPayload | null;
  stateId: string;
}

export default defineComponent({
  setup(props, { emit }) {
    const state = reactive<GabaritoSelectorState>({
      stateReady: false,
      gabaritoInterno: useGabaritoService().getGabarito(props.idGabarito),
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2)
    });

    watch([props], () => {
      if (props.idGabarito != state.gabaritoInterno?.idGabarito) {
        state.gabaritoInterno = useGabaritoService().getGabarito(
          props.idGabarito
        );
      }
    });

    watch([state], () => {
      emit("after-set-gabarito", state.gabaritoInterno?.idGabarito ?? null);
    });

    const gabaritosDisponiveisInternal = computed(() => {
      if (props.gabaritosDisponiveis) {
        return props.gabaritosDisponiveis;
      }
      return useGabaritoService().getGabaritosAtivos();
    });

    onMounted(async () => {
      state.stateReady = true;
    });

    return {
      gabaritosDisponiveisInternal,
      ...toRefs(state)
    };
  },
  props: {
    required: {
      type: Boolean
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    },
    idGabarito: {
      type: Number
    },
    gabaritosDisponiveis: {
      type: Array as PropType<Array<GabaritoPayload>>,
      required: false
    },
    id: {
      type: String
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
